import { useQuery } from '@tanstack/react-query';
import { endpoints } from '@rossum/api-client';
import { Workflow } from '@rossum/api-client/workflows';
import { WorkflowStep } from '@rossum/api-client/workflowSteps';
import { api } from '../../../../lib/apiClient';

export type WorkflowQueueUsage = {
  id: number;
  name: string;
};

export type WorkflowWithSteps = Workflow & {
  steps: WorkflowStep[];
  queues: WorkflowQueueUsage[];
};

export const useWorkflowsWithSteps = () =>
  useQuery({
    queryKey: ['workflows', 'settings', 'workflowsWithSteps'] as const,

    queryFn: async (): Promise<WorkflowWithSteps[]> => {
      const [workflows, steps, queues] = await Promise.all([
        api.unpaginatedRequest(endpoints.workflows.list)(),
        api.unpaginatedRequest(endpoints.workflowSteps.list)(),
        api.unpaginatedRequest(endpoints.queues.list)({
          fields: ['id', 'name', 'url', 'workflows'],
        }),
      ]);

      return workflows.map(workflow => ({
        ...workflow,
        steps: steps
          .filter(step => step.workflow === workflow.url)
          .sort((a, b) => a.ordering - b.ordering),
        queues: queues
          .filter(queue =>
            queue.workflows.some(({ url }) => url === workflow.url)
          )
          .map(queue => ({ id: queue.id, name: queue.name })),
      }));
    },
  });
